import React from "react";
import { observer, inject } from "mobx-react";
import { ColorOptionsWithAlternate } from "../models/ColorOptionModel";
import ColorsStore from "../stores/ColorsStore";
import ImageContainer from "./ImageContainer";
import ModelPicker from "./ModelPicker";
import classNames from "classnames";

interface HybridColorPickerProps {
  content: ColorOptionsWithAlternate;
}

interface HybridColorPickerState {}

interface InjectedProps extends HybridColorPickerProps {
  ColorsStore: ColorsStore;
}

@inject("ColorsStore")
@observer
class HybridColorPicker extends React.Component<
  HybridColorPickerProps,
  HybridColorPickerState
> {
  constructor(props) {
    super(props);
  }

  get injected() {
    return this.props as InjectedProps;
  }

  componentDidMount() {
    const { ColorsStore } = this.injected;
    const { content } = this.props;
    ColorsStore.fetchColorOptions(content.colours);
  }

  render() {
    const { content } = this.props;
    const { ColorsStore } = this.injected;
    const { colorOptions } = ColorsStore;
    const selectedColor = ColorsStore.colorOption;

    const colorText = !!selectedColor ? selectedColor.name : null;
    const imgSrc = !!selectedColor
      ? selectedColor.colourImages[ColorsStore.displayIndex]
      : null;

    return (
      <div className="customise-car__image-container">
        {content.alternateColours && (
          <ModelPicker
            content={content}
            defaultModel="Crosstrek"
            alternateModel="Forester"
          />
        )}

        {selectedColor ? (
          <ImageContainer
            colorsStore={ColorsStore}
            imgSrc={imgSrc}
            colorText={colorText}
          />
        ) : null}
        <ul className="dot-navigator">
          {selectedColor &&
            selectedColor.colourImages.map((image, index) => {
              const dotLiClass = classNames({
                "gallery-dot__li-small": ColorsStore.displayIndex !== index,
                "gallery-dot__li-big": ColorsStore.displayIndex === index,
              });
              const dotClass = classNames({
                "gallery-dot": true,
                "gallery-dot__active": ColorsStore.displayIndex === index,
              });

              return (
                <li
                  className={dotLiClass}
                  key={index}
                  onClick={(e) => {
                    e.preventDefault();
                    ColorsStore.navigateToIndex(index);
                  }}
                >
                  <div className={dotClass}></div>
                </li>
              );
            })}
        </ul>
        <ul>
          {colorOptions &&
            colorOptions.map((colorOption) => {
              const isSelected =
                !!selectedColor && selectedColor.name === colorOption.name;
              return (
                <li
                  key={`color-${colorOption.name}`}
                  className="customise-car__swatch"
                >
                  <a
                    href="#"
                    className={isSelected ? "is-active" : ""}
                    onClick={(e) => {
                      e.preventDefault();

                      ColorsStore.onColorOptionSelected(colorOption);
                    }}
                    data-color={colorOption.name}
                    data-toggle="tooltip"
                    title={colorOption.name}
                  >
                    <span
                      className="swatch__color"
                      style={{
                        backgroundColor: `#${colorOption.hexValue.value}`,
                      }}
                    >
                      {colorOption.name}
                    </span>
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}

export default HybridColorPicker;
